import { Link } from 'react-router-dom';
import { MapPin, Phone, Mail, Facebook } from 'lucide-react';

// TikTok icon component since lucide-react doesn't have it
const TikTokIcon = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" fill="currentColor">
    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z"/>
  </svg>
);

export const Footer = () => {
  return (
    <footer data-testid="main-footer" className="bg-foreground text-background">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          <div data-testid="footer-about" className="space-y-4">
            <div className="flex items-center space-x-3">
              <img 
                src="https://customer-assets.emergentagent.com/job_earthy-interact/artifacts/nz39lewe_IMG_20260129_120644.png"
                alt="Christ Refuge Community Church"
                className="h-12 w-auto"
              />
              <div className="flex flex-col">
                <span className="text-lg font-heading font-bold leading-tight">Christ Refuge</span>
                <span className="text-xs text-background/70 tracking-wide">Community Church</span>
              </div>
            </div>
            <p className="text-sm text-background/80 leading-relaxed">
              Igniting Faith. Empowering Lives. Transforming Generations.
            </p>
            <p className="text-xs text-background/70 mt-2">
              Bishop Kenneth & Apostle Yolanda Browne - Overseers<br />
              Pastors Dwayne & Lady Tessa Darden - Lead Pastors
            </p>
          </div>

          <div data-testid="footer-quick-links" className="space-y-4">
            <h3 className="text-lg font-heading font-semibold">Quick Links</h3>
            <ul className="space-y-2">
              {['About', 'Services', 'Sermons', 'Events', 'Give', 'Contact'].map((item) => (
                <li key={item}>
                  <Link
                    to={`/${item.toLowerCase()}`}
                    data-testid={`footer-link-${item.toLowerCase()}`}
                    className="text-sm text-background/80 hover:text-primary transition-colors duration-300 inline-block hover:translate-x-1 transform"
                  >
                    {item}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div data-testid="footer-contact" className="space-y-4">
            <h3 className="text-lg font-heading font-semibold">Contact</h3>
            <ul className="space-y-3">
              <li className="flex items-start space-x-3">
                <MapPin className="w-5 h-5 text-primary mt-0.5 flex-shrink-0" />
                <span className="text-sm text-background/80">
                  5700 East 191st Street<br />
                  Belton, MO 64012
                </span>
              </li>
              <li className="flex items-center space-x-3">
                <Phone className="w-5 h-5 text-primary flex-shrink-0" />
                <a href="tel:8168760470" className="text-sm text-background/80 hover:text-primary transition-colors duration-300">
                  (816) 876-0470
                </a>
              </li>
              <li className="flex items-center space-x-3">
                <Mail className="w-5 h-5 text-primary flex-shrink-0" />
                <span className="text-sm text-background/80">Sunday @ 11:00 AM</span>
              </li>
            </ul>
          </div>

          <div data-testid="footer-connect" className="space-y-4">
            <h3 className="text-lg font-heading font-semibold">Connect</h3>
            <p className="text-sm text-background/80">Follow us on social media</p>
            <div className="flex space-x-4">
              <a
                href="https://www.facebook.com/share/g/16zNaLqYsY/?mibextid=wwXIfr"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-social-facebook"
                className="w-10 h-10 rounded-full bg-background/10 hover:bg-primary flex items-center justify-center transition-all duration-300 hover:scale-110"
                aria-label="Facebook"
              >
                <Facebook className="w-5 h-5" />
              </a>
              <a
                href="https://www.tiktok.com/@crcc2009?_r=1&_t=ZT-94ng7CmEEbF"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-social-tiktok"
                className="w-10 h-10 rounded-full bg-background/10 hover:bg-primary flex items-center justify-center transition-all duration-300 hover:scale-110"
                aria-label="TikTok"
              >
                <TikTokIcon className="w-5 h-5" />
              </a>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-background/20 text-center">
          <p className="text-sm text-background/70">
            &copy; {new Date().getFullYear()} Christ Refuge Community Church. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};
